<template>
    <v-app id="mg_theme">
        <svg-sprites />
        <header-tag />

        <search-banner />

        <v-content>
            <nuxt />
        </v-content>

        <footer-tag />
    </v-app>
</template>

<script>
import SearchBanner from '~/components/molecules/SearchBanner'
import SvgSprites from '~/components/SvgSprites'
import HeaderTag from '~/components/molecules/HeaderTag'
import FooterTag from '~/components/molecules/FooterTag'

export default {
    name: 'App',
    components: { SearchBanner, FooterTag, HeaderTag, SvgSprites },
    head: { htmlAttrs: { lang: 'ja' } },
    data: () => ({
        transitionName: 'fade'
    })
}
</script>

<style lang="scss"></style>
